import React from "react";
import { FunctionFactory } from "survey-core";
import { Goals } from "../quiz/goals";
import { Gender } from "../quiz/gender";
import { getTestimonialByName, TestimonialKey } from "./testimonials";
import { Physiology } from "../quiz/physiology";
import { getGenderKey } from "../features/utils";

const goalTargetSplashHtml = `
<div class="new-quote-container">
  <div class="splash-header">
    <h1>Real results that last.</h1>
    <div class="quote">{goalMuscleGainQuote} {goalGenderText}</div>
  </div>
  <div class="quote-img-container">
    <img class="testimonial-image" src="{goalGenderImageUrl}" alt="Testimonial from a user like you!"/>
  </div>
  <div class="small-text">{goalGenderName} - Verified Built With Science User</div>
</div>`;

const goalTargetSplashExpression = {
  name: "goalMuscleGainQuote",
  expression: "renderGoalTargetSplash({goals})",
};

const muscleGainImageUrlMap = {
  [Goals.LoseFat]: {
    [Gender.Male]: getTestimonialByName("Cesar"),
    [Gender.Female]: getTestimonialByName("Katy"),
  },
  [Goals.BuildMuscle]: {
    [Gender.Male]: getTestimonialByName("Abdullah"),
    [Gender.Female]: getTestimonialByName("Tahnee"),
  },
  [Goals.BuildMuscleAndLoseFat]: {
    [Gender.Male]: getTestimonialByName("Stephen"),
    [Gender.Female]: getTestimonialByName("Salma"),
  },
} as const;

function renderGoalTargetSplash(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as Goals) {
    case Goals.LoseFat:
      return `Our members lose weight at an average rate of 0.7% of their bodyweight per week.\nAny faster than this and you risk losing muscle.`;
    case Goals.BuildMuscle:
      return `With the right plan, most people gain 1-3 lbs of lean muscle per month.`;
    case Goals.BuildMuscleAndLoseFat:
      return `Our members drop around 1-3% body fat a month while building muscle.`; // we want to change this to 2-3%
  }
}

FunctionFactory.Instance.register(
  "renderGoalTargetSplash",
  renderGoalTargetSplash
);

const extractParamValue = (params: any[], prop: TestimonialKey): string => {
  if (params[0] == null || params[1] == null) return "";

  const goals = params[0] as Goals;
  const gender = params[1] as Gender;
  const physiology = params[2] as Physiology;
  const genderKey = getGenderKey(gender, physiology);
  return muscleGainImageUrlMap[goals]?.[genderKey][prop] ?? "";
};

const renderGoalGenderImageUrl = (params: any[]): string =>
  extractParamValue(params, "image");
const renderGoalGenderText = (params: any[]): string =>
  extractParamValue(params, "testimonial");
const renderGoalGenderName = (params: any[]): string =>
  extractParamValue(params, "displayName");

FunctionFactory.Instance.register(
  "goalGenderImageUrl",
  renderGoalGenderImageUrl
);
FunctionFactory.Instance.register("goalGenderText", renderGoalGenderText);
FunctionFactory.Instance.register("renderGoalGenderName", renderGoalGenderName);

const goalGenderImageUrlExpression = {
  name: "goalGenderImageUrl",
  expression: "goalGenderImageUrl({goals}, {gender}, {physiology})",
};

const goalGenderTextExpression = {
  name: "goalGenderText",
  expression: "goalGenderText({goals}, {gender}, {physiology})",
};

const goalGenderNameExpression = {
  name: "goalGenderName",
  expression: "renderGoalGenderName({goals}, {gender}, {physiology})",
};

const goalTargetSplashElement = {
  name: "goal-target-splash",
  type: "html",
  html: goalTargetSplashHtml,
};

const GoalTargetSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      📸 Framing expectations
    </div>
  );
};

export {
  goalTargetSplashElement,
  goalTargetSplashExpression,
  goalGenderImageUrlExpression,
  goalGenderNameExpression,
  goalGenderTextExpression,
  GoalTargetSplashHeader,
};
